var map = {
	"./Add_Kodansha.svg": 21225,
	"./Anime_Kodansha.svg": 39135,
	"./Art Book_Kodansha.svg": 55395,
	"./Books_Kodansha.svg": 18989,
	"./Data_Kodansha.svg": 50182,
	"./Deals_Kodansha.svg": 72526,
	"./Direction_Kodansha.svg": 12740,
	"./Direction_No_Border_Kodansha.svg": 34142,
	"./Document_Kodansha.svg": 41634,
	"./Events_Kodansha.svg": 5095,
	"./File_Kodansha.svg": 49855,
	"./Games_Kodansha.svg": 40745,
	"./Giveaway_Kodansha.svg": 41272,
	"./Level_Kodansha.svg": 78695,
	"./Live Action_Kodansha.svg": 35724,
	"./Location_Kodansha.svg": 59536,
	"./Magazine_Kodansha.svg": 84087,
	"./Mail_Kodansha.svg": 75587,
	"./Manga_Kodansha.svg": 17076,
	"./Map_Kodansha.svg": 53620,
	"./Men_Kodansha.svg": 58182,
	"./Music_Kodansha.svg": 53818,
	"./Novel_Kodansha.svg": 79770,
	"./Outdoors_Kodansha.svg": 10225,
	"./Photo_Kodansha.svg": 57372,
	"./Picture Book_Kodansha.svg": 97473,
	"./Pin_Kodansha.svg": 78538,
	"./Quote_Kodansha.svg": 23226,
	"./Reading Room_Kodansha.svg": 32962,
	"./Returns_Kodansha.svg": 62985,
	"./Sales_Kodansha.svg": 53573,
	"./Shipping_Kodansha.svg": 43827,
	"./Sport_Kodansha.svg": 81843,
	"./Stairs_Kodansha.svg": 96750,
	"./Survey_Kodansha.svg": 60923,
	"./Sweepstakes_Kodansha.svg": 69183,
	"./Weather_Kodansha.svg": 21081,
	"./Women_Kodansha.svg": 65779
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 94013;